import React from 'react'
import { Box } from '@mui/material'

interface AnswersImageProps {
  size?: number
  className?: string
}

/**
 * AnswersImage - Uses the actual answer_image.png from public assets
 * Shows the exact assessment questions image as provided
 */
export const AnswersImage: React.FC<AnswersImageProps> = ({ size = 240, className = '' }) => {
  return (
    <Box
      className={className}
      sx={{
        width: `${size}px`,
        height: `${size}px`,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <img
        src="/assets/img/answer_image.png"
        alt="Assessment Questions"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'contain'
        }}
      />
    </Box>
  )
}
